import React from "react";

import { withRouter } from "react-router";

import AdminService from "../../../services/admin/AdminService";
import ServiceViewService from "../../../services/serviceView/ServiceViewService";

import AdminPage from "../common/AdminPage";
import ServiceView from "@cdkglobal/epay-admin-component/cjs/components/_onePay/middle/serviceView/ServiceView";

const ServiceViewPage = ({ history }) => {
  return (
    <AdminPage showGoBackLink={true} history={history}>
      <ServiceView
        loadDepartments={AdminService.getStores}
        loadServiceViewConfigs={ServiceViewService.getServiceViewConfigs}
        onCreateServiceViewConfig={ServiceViewService.createServiceViewConfig}
        onUpdateServiceViewConfig={ServiceViewService.updateServiceViewConfig}
        onDeleteServiceViewConfig={ServiceViewService.deleteServiceViewConfig}
      />
    </AdminPage>
  );
};

export default withRouter(ServiceViewPage);
